export const SVS_LOW_RESPONSE_THRESHOLD = 10;
export const SVS_FEEDBACK_MODAL_MODE = {
    RAW: 'raw',
    AI_GENERATED: 'ai-generated'
};
